import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Track from "@/pages/Track";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Resources from "@/pages/Resources";
import ResourcePost from "@/pages/ResourcePost";
import Pricing from "@/pages/Pricing";
import Demo from "@/pages/Demo";
import Quote from "@/pages/Quote";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/track" element={<Track />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/industries" element={<Industries />} />
                    <Route path="/resources" element={<Resources />} />
                    <Route path="/resources/:slug" element={<ResourcePost />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/demo" element={<Demo />} />
                    <Route path="/quote" element={<Quote />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "rgba(20, 20, 31, 0.95)",
                        border: "1px solid rgba(0, 240, 255, 0.25)",
                        color: "#F4F4F5",
                    },
                }}
            />
        </div>
    );
}

export default App;
